import React from 'react'
import styled from 'styled-components'
import { SvgAttr } from '../SvgAttr/SvgAttr'

export const IconEmail = ({
  classes = '',
  styles,
  width = '40px',
  height = '40px',
  color = 'currentColor',
}) => {
  return (
    <Svg
      viewBox='0 0 72 72'
      className={classes}
      styles={styles}
      width={width}
      height={height}
      xmlns='http://www.w3.org/2000/svg'
      version='1.1'
    >
      <title>Email</title>
      <Path
        color={color}
        d='M61.76,58.46H10.48c-3.14-.62-5.11-2.6-5.91-5.67V19.24c.8-3.13,2.97-5.3,6.26-5.67,17.35.23,33.2-.02,50.47-.02,4.57.25,6.15,3.06,6.12,5.81,0,10.4,0,22.31,0,32.84,0,3.32-2.56,5.45-5.67,6.26ZM61.05,17.11H11.19l24.93,24.56,24.93-24.56ZM8.35,19v34.38c-.07.52.39,1.18,1.18,1.43h.47s17-17.23,17-17.23L8.35,19ZM64.12,19l-19.12,18.99,16.77,16.82.53.08c.73-.11,1.83-1.6,1.83-2.21V19ZM57.27,55.15l-14.57-14.87-5.86,5.67c-.42.34-1.03.34-1.44,0l-5.89-5.91-15.01,15.12h42.77Z'
      />
    </Svg>
  )
}

const Svg = styled(SvgAttr)`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  ${(props) => props.styles}
`

const Path = styled.path`
  transition: all 0.2s ease-in-out;
  fill: ${(props) => props.color};
`
